import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';
import { SystemService } from '@shared/service/system/system.service';

@Injectable({ providedIn: 'root' })
export class OrganisationViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);
  private systemService = inject(SystemService);

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return this.routeGuardService.handleRoute(this.getView(route), route);
  }
  getView(route?: ActivatedRouteSnapshot): View {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    return {
      route: `companies/${uuid}`,
      iframeUrl: `company/${uuid}`,
    };
  }
}
